module.exports = __webpack_public_path__ + "2-40.jpg?59a473f77b8cd6b3a2d76c4d4bfcc2e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-40.jpg
// module id = 117
// module chunks = 0